import type { Dictionary } from './en';

export const es: Dictionary = {
  'common.cancel': 'Cancelar',
  'common.back': 'Volver',
  'common.retry': 'Reintentar',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.share': 'Compartir',
  'common.delete': 'Eliminar',
  'common.revoke': 'Revocar',
  'common.close': 'Cerrar',
  'common.loading': 'Cargando',
  'common.optional': 'Opcional',
  'common.or': 'o',
  'common.none': 'Ninguno',
  'common.required': 'Obligatorio',
  'common.notSet': 'Sin definir',
  'common.skipToContent': 'Ir al contenido principal',
  'common.moment': 'Un momento…',

  'brand.tagline': 'Comparte un vídeo. Una sola vez.',
  'brand.home': 'BOOMSHOT - inicio',
  'brand.footerLimit':
    'BOOMSHOT garantiza una reproducción única segura. Ninguna tecnología puede impedir una captura o una grabación de pantalla.',

  'nav.main': 'Navegación principal',
  'nav.myVideos': 'Mis vídeos',
  'nav.privacy': 'Privacidad',
  'nav.signIn': 'Iniciar sesión',
  'nav.signOut': 'Cerrar sesión',
  'nav.settings': 'Ajustes de la cuenta',
  'nav.openMenu': 'Abrir el menú',
  'nav.closeMenu': 'Cerrar el menú',

  'theme.light': 'Tema claro - cambiar a oscuro',
  'theme.dark': 'Tema oscuro - cambiar a automático',
  'theme.system': 'Tema automático - cambiar a claro',
  'theme.label': 'Apariencia',
  'theme.optionSystem': 'Automático',
  'theme.optionLight': 'Claro',
  'theme.optionDark': 'Oscuro',

  'language.label': 'Idioma',
  'language.change': 'Cambiar de idioma',

  'landing.title': 'Comparte un vídeo. Una sola vez.',
  'landing.subtitle':
    'Tu enlace privado deja de funcionar tras la primera reproducción y el vídeo se elimina automáticamente.',
  'landing.ctaNew': 'Crear un enlace privado',
  'landing.ctaSend': 'Enviar un vídeo',
  'landing.haveAccount': 'Ya tengo una cuenta',
  'landing.assure.encrypted': 'Cifrado en tránsito',
  'landing.assure.deleted': 'Eliminado tras la reproducción',
  'landing.assure.noReplay': 'Sin repetición',
  'landing.how': 'Tres pasos. Ninguna segunda oportunidad.',
  'landing.step1.title': 'Envía',
  'landing.step1.body':
    'Suelta un vídeo. Se convierte en fragmentos servidos desde un almacenamiento privado, nunca desde una URL pública.',
  'landing.step2.title': 'Configura',
  'landing.step2.body':
    'Caducidad, código de acceso, marca de agua, mensaje. El enlace lleva un secreto que nunca sale de tu dispositivo.',
  'landing.step3.title': 'Una sola reproducción',
  'landing.step3.body':
    'La primera sesión reserva el enlace de forma definitiva. Al terminar, los archivos se destruyen en el servidor.',
  'landing.limits.title': 'Lo que BOOMSHOT hace',
  'landing.limits.guaranteed': 'Garantizado en el servidor',
  'landing.limits.g1': 'Una sola sesión de reproducción por enlace, reservada de forma atómica.',
  'landing.limits.g2': 'Fragmentos servidos con tokens de vida corta, sin URL permanente.',
  'landing.limits.g3':
    'Eliminación verificada del archivo original, los fragmentos y las miniaturas.',

  'auth.signIn.title': 'Iniciar sesión',
  'auth.signIn.subtitle': 'Accede a tus vídeos y a tus enlaces activos.',
  'auth.signIn.submit': 'Iniciar sesión',
  'auth.signIn.noAccount': '¿Aún no tienes cuenta?',
  'auth.signIn.create': 'Crear una cuenta',
  'auth.signIn.magicLink': 'Recibir un enlace de acceso',
  'auth.signIn.usePassword': 'Usar una contraseña',
  'auth.signIn.forgot': 'He olvidado mi contraseña',
  'auth.signIn.magicSent':
    'Si existe una cuenta con esa dirección, acabamos de enviar un enlace de acceso. Solo funciona una vez.',
  'auth.signUp.title': 'Crear una cuenta',
  'auth.signUp.subtitle':
    'Necesitas una cuenta para enviar. Tus destinatarios nunca la necesitan.',
  'auth.signUp.submit': 'Crear mi cuenta',
  'auth.signUp.hasAccount': '¿Ya estás registrado?',
  'auth.signUp.terms':
    'Entiendo que un vídeo reproducido en un navegador siempre puede capturarse mediante una grabación de pantalla, y que BOOMSHOT garantiza una reproducción única, no una protección anticopia.',
  'auth.reset.title': 'He olvidado mi contraseña',
  'auth.reset.subtitle': 'Te enviaremos un enlace para restablecerla.',
  'auth.reset.submit': 'Enviar el enlace',
  'auth.reset.sent':
    'Si existe una cuenta con esa dirección, acabamos de enviar un correo para restablecerla. Revisa también la carpeta de spam.',
  'auth.reset.back': 'Volver al inicio de sesión',
  'auth.callback.title': 'Iniciando sesión',
  'auth.callback.subtitle': 'Comprobando tu enlace…',
  'auth.callback.invalid': 'Este no es un enlace de acceso válido.',
  'auth.callback.requestNew': 'Solicitar un enlace nuevo',
  'auth.google': 'Continuar con Google',
  'auth.email': 'Correo electrónico',
  'auth.emailPlaceholder': 'tu@ejemplo.com',
  'auth.password': 'Contraseña',
  'auth.passwordConfirm': 'Confirmar contraseña',
  'auth.passwordHint': 'Mínimo 10 caracteres, con mayúscula, minúscula y cifra.',
  'auth.magicHint': 'Recibirás un enlace de un solo uso, sin contraseña.',
  'auth.confirmEmailPrompt': 'Confirma tu correo electrónico para terminar el acceso',

  'authError.invalidCredential': 'Correo electrónico o contraseña incorrectos.',
  'authError.emailInUse':
    'No se ha podido crear esa cuenta. Prueba a iniciar sesión o a restablecer la contraseña.',
  'authError.weakPassword': 'Contraseña demasiado débil.',
  'authError.tooManyRequests': 'Demasiados intentos. Inténtalo dentro de unos minutos.',
  'authError.network': 'Sin conexión. Comprueba tu red.',
  'authError.popupClosed': 'La ventana se cerró antes de completar el acceso.',
  'authError.popupBlocked': 'El navegador ha bloqueado la ventana.',
  'authError.recentLogin': 'Por seguridad, vuelve a iniciar sesión antes de continuar.',
  'authError.invalidActionCode': 'Este enlace de acceso no es válido o ya se ha usado.',
  'authError.expiredActionCode': 'Este enlace de acceso ha caducado. Solicita uno nuevo.',
  'authError.generic': 'Algo ha ido mal. Inténtalo de nuevo.',

  'dashboard.title': 'Mis vídeos',
  'dashboard.subtitle': 'Cada enlace permite exactamente una sesión de reproducción.',
  'dashboard.send': 'Enviar un vídeo',
  'dashboard.metric.activeLinks': 'Enlaces activos',
  'dashboard.metric.watched': 'Vídeos vistos',
  'dashboard.metric.storage': 'Almacenamiento temporal',
  'dashboard.search': 'Buscar',
  'dashboard.searchPlaceholder': 'Buscar por nombre o destinatario',
  'dashboard.filters': 'Filtros',
  'dashboard.filterStatus': 'Estado',
  'dashboard.filterAll': 'Todos los estados',
  'dashboard.sort': 'Orden',
  'dashboard.sortNewest': 'Más recientes',
  'dashboard.sortOldest': 'Más antiguos',
  'dashboard.sortExpiring': 'Caducan antes',
  'dashboard.empty.title': 'Todavía no hay vídeos',
  'dashboard.empty.body':
    'Envía tu primer vídeo: se convertirá, se protegerá con un enlace de un solo uso y se eliminará tras la primera reproducción.',
  'dashboard.noResults.title': 'Sin resultados',
  'dashboard.noResults.body':
    'Ningún vídeo coincide con esta búsqueda. Prueba otro término o borra los filtros.',
  'dashboard.loadError': 'No se han podido cargar tus vídeos. Comprueba tu conexión.',
  'dashboard.loadBlocked': 'No se pudieron cargar tus vídeos. El servicio no está bien configurado - el problema no es tuyo.',
  'dashboard.expiresIn': 'Caduca {when}',
  'dashboard.viewedAt': 'Visto {when}',
  'dashboard.createdAt': 'Creado {when}',
  'dashboard.forRecipient': 'Para {name}',

  'status.processing': 'Procesando',
  'status.ready': 'Listo',
  'status.opened': 'Enlace abierto',
  'status.playing': 'Reproduciendo',
  'status.watched': 'Visto',
  'status.expired': 'Caducado',
  'status.deleted': 'Eliminado',
  'status.error': 'Error',

  'upload.title': 'Enviar un vídeo',
  'upload.subtitle':
    'Se convertirá, se protegerá con un enlace de un solo uso y se eliminará tras la primera reproducción.',
  'upload.drop': 'Suelta aquí tu vídeo',
  'upload.formats': '{formats} - hasta {size}',
  'upload.choose': 'Elegir un archivo',
  'upload.progress': 'Progreso del envío',
  'upload.inProgress': 'Enviando…',
  'upload.converting': 'Convirtiendo…',
  'upload.cancelUpload': 'Cancelar el envío',
  'upload.processingNote':
    'Convirtiendo a fragmentos seguros. No hace falta esperar: genera el enlace ahora y funcionará en cuanto esto termine.',
  'upload.restart': 'Empezar de nuevo',
  'upload.error.format': 'Formato no admitido. Usa un archivo MP4, MOV o WebM.',
  'upload.error.tooLarge': 'Archivo demasiado grande (máximo {size}).',
  'upload.error.notVideo': 'Este archivo no parece un vídeo válido.',
  'upload.error.unreadable': 'Este archivo no se ha podido leer como vídeo.',
  'upload.error.tooLong': 'Vídeo demasiado largo ({duration}). Máximo {max}.',
  'upload.error.failed': 'El envío ha fallado. Comprueba tu conexión e inténtalo de nuevo.',
  'upload.error.transcode':
    'La conversión de este vídeo ha fallado. El archivo se ha eliminado. Prueba con otro formato.',
  'upload.error.tracking': 'Se ha perdido el seguimiento del procesado. Recarga la página.',

  'config.expiry': 'Caducidad del enlace',
  'config.expiry1h': '1 hora',
  'config.expiry24h': '24 h',
  'config.expiry3d': '3 días',
  'config.expiry7d': '7 días',
  'config.expiryCustom': 'Fecha personalizada',
  'config.expiryDate': 'Fecha y hora de caducidad',
  'config.pin': 'Código de acceso',
  'config.pinHint': 'De 4 a 8 cifras. Envíalo aparte del enlace.',
  'config.advanced': 'Opciones avanzadas',
  'config.internalName': 'Nombre interno',
  'config.internalNameHint': 'Visible solo para ti, nunca para el destinatario.',
  'config.recipient': 'Nombre del destinatario',
  'config.recipientHint': 'Se muestra en la marca de agua cuando está activada.',
  'config.watermark': 'Marca de agua',
  'config.watermarkNone': 'Ninguna',
  'config.watermarkSubtle': 'Discreta',
  'config.watermarkReinforced': 'Reforzada',
  'config.message': 'Mensaje al destinatario',
  'config.messagePlaceholder': 'Opcional - se muestra antes de la reproducción',
  'config.submit': 'Crear el enlace privado',
  'config.alwaysDeleted':
    'La eliminación tras la reproducción siempre está activa y no se puede desactivar.',
  'config.linkFailed': 'No se ha podido generar el enlace.',

  'ready.eyebrow': 'Enlace generado',
  'ready.title': 'Tu enlace está listo. Funciona una vez.',
  'ready.meta': '{name} · {duration} · caduca el {date}',
  'ready.stillProcessing':
    'Este enlace ya funciona, pero el vídeo todavía se está procesando. Si se abre de inmediato, el destinatario solo tendrá que esperar un momento.',
  'ready.secureLink': 'Enlace seguro',
  'ready.copyFailed': 'No se ha podido copiar. Selecciona el enlace manualmente.',
  'ready.shareTitle': 'Vídeo de reproducción única',
  'ready.shareText': 'Este vídeo solo puede verse una vez.',
  'ready.pinWarning':
    'El código de acceso se excluye deliberadamente del envío. Transmítelo por otro canal (SMS, llamada), nunca en el mismo mensaje que el enlace.',
  'ready.fragmentNote':
    'La parte del enlace posterior al {hash} es el secreto de acceso. Nunca se envía a nuestros servidores: copia el enlace entero.',
  'ready.protections': 'Protecciones activas',
  'ready.protectionSingle': 'Una sola sesión de reproducción',
  'ready.protectionDelete': 'Eliminación tras la reproducción',
  'ready.protectionPin': 'Código de acceso obligatorio',
  'ready.protectionsNote':
    'Estas medidas garantizan una reproducción única. No pueden impedir una captura ni una grabación de pantalla.',
  'ready.qr': 'Código QR',
  'ready.qrAlt': 'Código QR del enlace seguro para {name}',
  'ready.sendAnother': 'Enviar otro vídeo',
  'ready.backToDashboard': 'Volver al panel',
  'ready.leaveWarnTitle': 'Aún no has copiado este enlace',
  'ready.leaveWarnBody':
      'Es la única vez que se muestra. No se guarda en ningún sitio: si sales ahora sin copiarlo ni compartirlo, nadie - ni siquiera tú - podrá recuperarlo después. Tendrías que revocar el enlace de este vídeo y volver a enviarlo.',
  'ready.leaveAnyway': 'Salir sin copiar',
  'ready.copyNow': 'Copiar el enlace',
  'ready.watermarkNone': 'Sin marca de agua',
  'ready.watermarkSubtle': 'Marca de agua discreta',
  'ready.watermarkReinforced': 'Marca de agua reforzada',

  'detail.notFound.title': 'Vídeo no encontrado',
  'detail.notFound.body': 'Este vídeo ya no existe o no te pertenece.',
  'detail.duration': 'Duración',
  'detail.size': 'Tamaño',
  'detail.created': 'Creado el',
  'detail.recipient': 'Destinatario',
  'detail.expiry': 'Caducidad',
  'detail.viewedOn': 'Visto el',
  'detail.deletedOn': 'Eliminado el',
  'detail.pinRequired': 'Obligatorio',
  'detail.consumedNote':
    'Este vídeo ya se ha visto. El enlace es definitivamente inservible y los archivos se han eliminado del almacenamiento.',
  'detail.failedNote':
    'El procesado de este vídeo ha fallado. No se generó ningún enlace y los archivos temporales se han eliminado.',
  'detail.lastError': 'Último error notificado por el servidor:',
  'detail.copyLink': 'Copiar el enlace',
  'detail.secretLost':
    'El secreto del enlace nunca se guarda: solo aparece al generarlo. Revoca este enlace y crea uno nuevo si lo has perdido.',
  'detail.revoke': 'Revocar el enlace',
  'detail.deleteNow': 'Eliminar ahora',
  'detail.reuse': 'Reutilizar estos ajustes',
  'detail.revokeTitle': '¿Revocar este enlace?',
  'detail.revokeBody':
    'El enlace dejará de funcionar de inmediato. Después se eliminará el vídeo.',
  'detail.revoked': 'Enlace revocado.',
  'detail.deleteTitle': '¿Eliminar este vídeo?',
  'detail.deleteBody':
    'El archivo original, los fragmentos y las miniaturas se destruirán. Esta acción es irreversible.',
  'detail.deleteStarted': 'Eliminación iniciada.',
  'detail.actionFailed': 'Esta acción no es posible ahora mismo.',

  'settings.title': 'Cuenta y privacidad',
  'settings.subtitle': 'Lo que BOOMSHOT conserva y lo que no puede garantizar.',
  'settings.identity': 'Identidad',
  'settings.anonymous': 'Cuenta anónima',
  'settings.memberSince': 'Miembro desde {date}',
  'settings.dataKept': 'Datos conservados',
  'settings.dataKept1':
    'Tras eliminar un vídeo, BOOMSHOT solo guarda un rastro mínimo: estado, fecha de creación, fecha de visualización, fecha de eliminación, duración y el nombre que elegiste.',
  'settings.dataKept2':
    'No se almacena ninguna dirección IP completa. No queda ninguna miniatura, ningún fragmento de vídeo ni ningún archivo original.',
  'settings.limitsTitle': 'Límites reales de la protección',
  'settings.limits1':
    'Un vídeo reproducido en un navegador siempre puede copiarse: captura de pantalla, grabación de pantalla, una cámara externa filmando la pantalla o extracción por parte de alguien con conocimientos técnicos.',
  'settings.limits2':
    'BOOMSHOT garantiza que un enlace abre exactamente una sesión de reproducción y que después los archivos se destruyen en el servidor. No garantiza que la imagen no pueda copiarse.',
  'settings.deleteAccount': 'Eliminar la cuenta',
  'settings.deleteAccountBody':
    'Se destruirán todos tus vídeos, enlaces y archivos. Esta acción es irreversible.',
  'settings.deleteConfirmLabel': 'Escribe ELIMINAR para confirmar',
  'settings.deleteConfirmWord': 'ELIMINAR',
  'settings.deleteSubmit': 'Eliminar definitivamente mi cuenta',
  'settings.deleted': 'Cuenta eliminada.',
  'settings.signOutFailed': 'No se ha podido cerrar la sesión ahora mismo.',

  'viewer.checking': 'Comprobando el enlace…',
  'viewer.preparing': 'Casi listo: el vídeo del remitente todavía se está preparando.',
  'viewer.eyebrow': 'Reproducción única',
  'viewer.title': 'Este vídeo solo puede verse una vez.',
  'viewer.subtitle':
    'Empiézalo cuando estés listo y asegúrate de tener una conexión estable.',
  'viewer.sender': 'Remitente',
  'viewer.message': 'Mensaje',
  'viewer.duration': 'Duración',
  'viewer.deadline': 'Disponible hasta',
  'viewer.warning':
    'En cuanto inicies la reproducción, el enlace quedará inservible para siempre. No habrá repetición, ni rebobinado, ni una segunda sesión, aunque cierres la página por accidente.',
  'viewer.start': 'Empezar la reproducción única',
  'viewer.startWithPin': 'Validar y empezar la reproducción única',
  'viewer.pinHint': 'El remitente te ha enviado este código por separado.',
  'viewer.pinWrong': 'Código incorrecto.',
  'viewer.pinWrongRetry': 'Código incorrecto. Inténtalo dentro de {seconds} s.',
  'viewer.retryIn': 'Nuevo intento dentro de {seconds} s',
  'viewer.noPreload': 'No se carga ningún fragmento de vídeo antes de tu confirmación.',
  'viewer.checkFailed': 'No se ha podido comprobar este enlace ahora mismo.',
  'viewer.claimFailed': 'No se ha podido abrir la sesión de reproducción.',
  'viewer.unavailable.title': 'Este enlace ya no es válido',
  'viewer.unavailable.body':
    'Puede que ya se haya usado o revocado, o puede que nunca haya existido. Por privacidad no podemos decir más. Pide un enlace nuevo al remitente.',
  'viewer.expired.title': 'Este enlace ha caducado',
  'viewer.expired.body':
    'La fecha límite fijada por el remitente ya ha pasado y el vídeo se ha eliminado. Pide un enlace nuevo si todavía necesitas verlo.',
  'viewer.used.title': 'Este vídeo ya se ha abierto',
  'viewer.used.body':
    'Ya se inició una sesión de reproducción para este enlace. No puede crear otra y el vídeo se ha eliminado.',
  'viewer.stillProcessing.title': 'Este vídeo todavía se está preparando',
  'viewer.stillProcessing.body':
    'Esto está tardando más de lo habitual. El enlace funciona bien: vuelve a abrirlo en unos minutos y debería estar listo.',
  'viewer.consumed.title': 'Vídeo visto y eliminado',
  'viewer.consumed.body':
    'La reproducción ha terminado. El enlace ya es inservible y los archivos se han destruido en nuestros servidores.',
  'viewer.error.title': 'Reproducción imposible',

  'player.preloading': 'Precarga segura…',
  'player.tapToPlay': 'Toca para reproducir',
  'player.tapToPlayHint': 'La visualización única empieza en cuanto pulsas reproducir.',
  'player.stalled': 'Conexión inestable - la reproducción se reanudará automáticamente.',
  'player.play': 'Reproducir',
  'player.pause': 'Pausar',
  'player.mute': 'Silenciar',
  'player.unmute': 'Activar el sonido',
  'player.volume': 'Volumen',
  'player.fullscreen': 'Pantalla completa',
  'player.exitFullscreen': 'Salir de pantalla completa',
  'player.progress': 'Progreso de la reproducción',
  'player.unsupported': 'Tu navegador no puede reproducir este vídeo.',
  'player.fatal': 'La reproducción se ha interrumpido y no puede reanudarse.',

  'notFound.title': 'Página no encontrada',
  'notFound.body':
    'Esta dirección no corresponde a nada. Si te han enviado un enlace de vídeo, comprueba que se copió entero: la parte posterior al {hash} es imprescindible.',
  'notFound.home': 'Volver al inicio',

  'apiError.network': 'Sin conexión. Comprueba tu red.',
  'apiError.unauthenticated': 'Sesión caducada. Vuelve a iniciar sesión.',
  'apiError.forbidden': 'Acceso denegado.',
  'apiError.notFound': 'No encontrado.',
  'apiError.conflict': 'Esta acción ya se ha realizado.',
  'apiError.rateLimited': 'Demasiados intentos. Inténtalo en un momento.',
  'apiError.badResponse': 'Respuesta inesperada del servidor.',
  'apiError.internal': 'Algo ha ido mal por nuestra parte.',
  'apiError.badRequest': 'Solicitud no válida.',

  'validation.required': 'Obligatorio',
  'validation.invalidFormat': 'Formato no válido',
  'validation.tooLong': 'Demasiado largo',
  'validation.unsafeCharacters': 'Caracteres no permitidos',
  'validation.email': 'Correo electrónico no válido',
  'validation.passwordMin': 'Mínimo 10 caracteres',
  'validation.passwordComplexity': 'Debe contener una minúscula, una mayúscula y una cifra',
  'validation.passwordMismatch': 'Las contraseñas no coinciden',
  'validation.termsRequired': 'Debes aceptar las condiciones',
  'validation.pinDigits': 'El código debe ser numérico',
  'validation.pinMin': 'Al menos {min} cifras',
  'validation.pinMax': 'Como máximo {max} cifras',
  'validation.messageTooLong': 'Mensaje demasiado largo (máximo 500 caracteres)',
  'validation.dateRequired': 'Elige una fecha',
  'validation.dateTooSoon': 'La fecha debe ser al menos 5 minutos en el futuro',
  'validation.dateTooFar': 'La fecha no puede superar los 30 días',
  'validation.confirmDelete': 'Escribe ELIMINAR para confirmar',

  'state.errorTitle': 'Algo ha ido mal',
};
